// extracted by mini-css-extract-plugin
export default {"btn":"scrollTop_btn__tWy1B"};